import { toast } from "react-toastify";
import api from "../api";
import { PUBLIC_ROUTES } from "./publicRoutes";
import i18next from "i18next";
import { t } from "i18next";

export const handleErrors = async (error) => {
  const { response } = error || {};
  const { status } = response || {};

  if (status === 401) {
    const currentPath = window.location.pathname;

    // proverava da li je trenutna ruta public
    const isPublicRoute = PUBLIC_ROUTES.some((path) =>
      currentPath.startsWith(path)
    );

    if (!isPublicRoute) {
      toast.error(t("error.expiredSession"), { theme: "colored" });
    }
    throw error;
  } else {
    if (error.response?.data instanceof Blob) {
      error.response.data = JSON.parse(await error.response.data.text());
    }
    throw error;
  }
};

const apiService = {
  get(url) {
    return api
      .get(url, {
        headers: getSimpleHeaders(),
      })
      .catch(handleErrors);
  },
  post(url, body) {
    return api
      .post(url, body, {
        headers: getSimpleHeaders(),
      })
      .catch(handleErrors);
  },
  postBlob(url, obj) {
    const blob = new Blob([JSON.stringify(obj)], { type: "application/json" });
    return api
      .post(url, blob, {
        // eksplicitno pošalji kao octet-stream
        headers: {
          "Content-Type": "application/octet-stream",
        },
        // spreči Axios da menja telo
        transformRequest: [(data) => data],
      })
      .catch(handleErrors);
  },
  postMultipart(url, body) {
    return api
      .post(url, body, {
        headers: getSimpleHeadersFile(),
      })
      .catch(handleErrors);
  },
  putMultipart(url, body) {
    return api
      .put(url, body, {
        headers: getSimpleHeadersFile(),
      })
      .catch(handleErrors);
  },
  patch(url, body) {
    return api.patch(url, body, {
      headers: getSimpleHeaders(),
    });
  },
  put(url, body) {
    return api
      .put(url, body, {
        headers: getSimpleHeaders(),
      })
      .catch(handleErrors);
  },
  delete(url) {
    return api
      .delete(url, {
        headers: getSimpleHeaders(),
      })
      .catch(handleErrors);
  },

  getFromFile(url) {
    return api
      .get(url, {
        responseType: "blob",
        headers: getSimpleHeaders(),
      })
      .catch(handleErrors);
  },
};

function getSimpleHeaders() {
  return {
    "Content-Type": "application/json",
    "Accept-Language": i18next.language || "sr",
  };
}

function getSimpleHeadersFile() {
  return {
    "Content-Type": "multipart/form-data",
    "Accept-Language": i18next.language || "sr",
  };
}

export default apiService;
